import { PropsWithChildren } from 'react';

import { useLocation } from 'react-router-dom';

import { useAbility } from '@cast/shared-ability-data-access';

import { SuspenseLoader } from 'components/loaders';
import { BASE_PATHS } from '@oneclick/constants/navigation';

/**
 * Bootstrap wait until ability rules are loaded (same role as main-console
 * Initializer's abilitiesLoaded). Not an access guard — ProtectedRoute still
 * enforces permissions. InitApp handles auth/org; this handles abilities after
 * AbilityProvider. Full-page loader only; no mid-load shell.
 */
export const WaitForAbilities = ({ children }: PropsWithChildren) => {
  const { isLoading } = useAbility();
  const { pathname } = useLocation();

  if (isLoading && pathname !== BASE_PATHS.forbidden) {
    return <SuspenseLoader />;
  }

  return <>{children}</>;
};
